import { LearningMenuType } from "@/components/Learning/LearningMiddle/config/LearningMenuType";
import type { LearningStoreGetters } from "@/store/learning/getters";
import type { LearningStoreState } from "@/store/learning/state";
import { createLinuxLearningState } from "@/store/learning/state/factories";
import { useLearningAssessmentStore } from "@/store/learning/assessment/learningAssessmentStore";
import { LinuxInstructionModel } from "~~/package/mapper/learning/model/linux/LinuxInstructionModel";
import { LinuxLearningModel } from "~~/package/mapper/learning/model/linux/LinuxLearningModel";
import { LevelAssessmentModel } from "~~/package/mapper/levelAssessment/model/LevelAssessmentModel";
import { TaskType } from "~~/package/mapper/learning/model/TaskType";
import {
    ProSkillAssureAssessmentModel
} from "~~/package/mapper/proSkillAssure/model/assessment/ProSkillAssureAssessmentModel";
import {
    ProSkillAssureAssessmentMyInfoModel
} from "~~/package/mapper/proSkillAssure/model/assessment/myInfo/ProSkillAssureAssessmentMyInfoModel";

export const domainActions = {
    updateContestList(isSubmitted?: boolean): void {
        const assessmentStore = useLearningAssessmentStore();
        assessmentStore.contestList.forEach(task => {
            if (task.taskTestTemplateId === assessmentStore.taskTestTemplateId) {
                if ([TaskType.CODE, TaskType.CODE_WITHOUT_RUN].includes(task.type as TaskType))
                    task.submitCode = (this as LearningStoreGetters).convertedCurrentCode;
                else if (TaskType.SHORT_QA === task.type)
                    task.submitCode = (this as LearningStoreState).descriptiveAnswer;
                else if (task.type === TaskType.MULTIPLE_CHOICE) {
                    task.lastAnswer = (this as LearningStoreState).task.multipleChoiceQuestion.multipleChoiceResult.answerList.map(answer => answer.toString());
                }

                if (isSubmitted) task.submissionFlag = true;
            }
        });
    },
    updateLinuxInstruction(linuxLearningData: LinuxLearningModel<LinuxInstructionModel[]>) {
        (this as LearningStoreState).linuxLearning = {
            ...createLinuxLearningState(),
            instructionList: (linuxLearningData.data as LinuxInstructionModel[]).sort((a, b) => a.order - b.order),
        };
        (this as LearningStoreState).menuType = LearningMenuType.Description;
    },
    completeLinuxInstruction(linuxInstruction: LinuxInstructionModel) {
        const completeInstruction = (this as LearningStoreState).linuxLearning.instructionList
            .find(instruction => instruction.order === linuxInstruction.order);
        if (completeInstruction) {
            completeInstruction.isCorrect = true;
        }
    },
    allCompleteLinuxInstruction() {
        (this as LearningStoreState).linuxLearning.isInstructionAllDone = true;
    },
    updateTrackLevelInfo(trackInfo: LevelAssessmentModel, levelId: string): void {
        useLearningAssessmentStore().updateTrackLevelInfo(trackInfo, levelId);
    },
    updateProSkillAssessmentInfo(id: number, assessment: ProSkillAssureAssessmentModel, myInfo: ProSkillAssureAssessmentMyInfoModel, remainingTime?: number): void {
        useLearningAssessmentStore().updateProSkillAssessmentInfo(id, assessment, myInfo, remainingTime);
    }
};
